import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { ToastService } from '../../shared/toast/toast.service';
import { environment } from '../../environments/environment';
import { ApiService, FileResponse } from '../../shared/services/api.service';
import { FileService } from '../../shared/services/file.service';
import { DateValidators } from '../../shared/validators/date.validators';

@Component({
  selector: 'app-performance-monitor',
  templateUrl: './performance-monitor.component.html',
  standalone: false,
})
export class PerformanceMonitorComponent implements OnInit, OnDestroy {
  public monitoringForm: FormGroup;
  public submitted: boolean = false;
  public selectedFile: File | undefined;

  constructor(
    private readonly fb: FormBuilder,
    private readonly toastService: ToastService,
    private readonly fileService: FileService,
    private readonly api: ApiService,
  ) {}
  private readonly destroy$: Subject<void> = new Subject();

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.monitoringForm = this.fb.group({
      beginDate: new FormControl<Date>(undefined, [DateValidators.dateFormatValidator, Validators.required]),
      endDate: new FormControl<Date>(undefined, [DateValidators.dateFormatValidator, Validators.required]),
    });
  }

  async onSubmit(): Promise<void> {
    this.submitted = true;

    if (this.monitoringForm.valid) {
      try {
        const uri: string = `${environment.api.performanceMonitor}/exportCSV`;
        const value = this.monitoringForm.value;
        const { filename, data }: FileResponse = await this.api.postWithFileResponse(uri, this.monitoringForm.value);
        this.fileService.saveAs(data, filename);

        this.toastService.show('export csv effectué sans erreur', 'success');
      } catch (err) {
        this.toastService.show("erreur lors de l'export CSV", 'danger');
      }
    }
  }
}
